import { BASE_URL } from 'constants/api';
import { stringify } from 'query-string';
import { createGetAPI, createPostAPI } from '@cuemath/rest-api';

const { useGet: useAcLedMappingSearchGet } = createGetAPI({
  getURL: (_, query) => `${BASE_URL}/demo/day-wise-supply/?${stringify(query)}`,
});

const { usePost: useAcLedMappingBookPacPost } = createPostAPI({
  getURL: _ => `${BASE_URL}/`,
});

const { usePost: useAcLedMappingPost } = createPostAPI({
  getURL: _ => `${BASE_URL}/demo/ac-mapping-logs`,
});

export { useAcLedMappingBookPacPost, useAcLedMappingSearchGet, useAcLedMappingPost };
